import * as t from "io-ts";
import { makeMessage } from "./shared.js";
import { areYouReady, ready, setState, triggerAction } from "./v2.js";
export { areYouReady, ready, setState, triggerAction };
export const cssVariables = t.type({
    "--color-accent": t.string
});
export const config = t.intersection([
    t.type({
        colorScheme: t.union([
            t.literal("light"),
            t.literal("dark"),
            t.literal("auto")
        ]),
        cssVariables
    }),
    t.partial({
        alpineConfig: t.intersection([
            t.type({
                mode: t.union([t.literal("standalone"), t.literal("collection")])
            }),
            t.partial({
                hasBodyAction: t.boolean
            })
        ])
    })
]);
export const setCSSVariables = makeMessage("glide:set-config", t.type({
    config
}));
export const messagesFromComponent = t.union([
    setState,
    setCSSVariables,
    areYouReady
]);
export const messagesFromIFrame = t.union([ready, setState, triggerAction]);
export const versionName = "v3";
